import { HttpClient, HttpEvent, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, DynamicFormDto, DynamicPayloadDto, FileUploadDto, MemberDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpFileService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/file', authService);
	}
	// public get(id: number): Observable<DynamicFormDto> {
	// 	return super.doGet(true, `/${id}`);
	// }
	public upload(name: string, formData: FormData): Observable<FileUploadDto> {
		return super.doPost(true, `/upload/${encodeURI(name)}`, formData);
	}

	uploadWithProgress(name: string, formData: FormData): Observable<HttpEvent<FileUploadDto>> {
		return super.doUploadFile(true, `/upload/${encodeURI(name)}`, formData);
	}
	downloadFile(uuid: string): Observable<any> {
		return super.doDownloadFile(true, `/${uuid}/download`);
	}
	public preview(uuid: string): Observable<HttpResponse<Blob>> {
		return super.doGetForFile(true, `/${uuid}/preview`);
	}
}
